/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { useMount, useUpdateEffect } from 'react-use';
import { useSelector, useDispatch } from 'react-redux';
import { Grid } from '@mui/material';
import RobotDirectRegisterCard from '../../components/robot/RobotDirectRegisterCard';
import AccordionCard from '../../components/AccordionCard';
import {
  onDirectSaveItem,
  updateRegisterItem,
  initRegisterItem,
} from '../../modules/robot';
import { Alert } from '../../common/util';
import Toast from '../../components/Toast';
// import { checkSerialAPI } from '../api/robot';

const RobotRegisterContainer = () => {
  const dispatch = useDispatch();
  const state = useSelector((rootState) => rootState.robot);
  const { registerItem, saved, error } = state;
  const [open, setOpen] = useState(true);
  const [doneDisabled, setDoneDisabled] = useState(false);
  const [snack, setSnack] = useState({ open: false });

  const onOpen = () => {
    dispatch(initRegisterItem());
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onItemChange = (item) => {
    const { v, n } = item;
    const changeItems = n.split('-');
    const prop = changeItems[0];
    const event = changeItems[1];
    let newValue;
    if (prop === 'serials') {
      if (event === 'add') {
        if (registerItem.serials.find((serial) => serial === v)) {
          return Alert('이미 추가한 시리얼입니다.');
        }
        newValue = registerItem.serials.concat(v);
      }
      if (event === 'delete') {
        const index = registerItem.serials.indexOf(v);
        const serials = [...registerItem.serials];

        serials.splice(index, 1);
        newValue = [...serials];
      }
    } else {
      newValue = v;
    }
    const newRegisterItem = { ...registerItem, [prop]: newValue };
    return dispatch(updateRegisterItem(newRegisterItem));
  };

  const handleSnackClose = () => {
    setSnack({ open: false });
  };

  useUpdateEffect(() => {
    let changed = false;
    let e = '';
    if (registerItem.error) {
      changed = true;
      e += Object.values(registerItem.error).join('');
    }
    setDoneDisabled(!changed || (changed && e.length !== 0));
  }, [registerItem]);

  useUpdateEffect(() => {
    if (saved && saved.length === registerItem.serials.length) {
      setSnack({
        open: true,
        onClose: () => {
          handleSnackClose();
          dispatch(initRegisterItem());
        },
        message: `${saved.length}개의 로봇이 등록되었습니다.`,
        severity: 'success',
        duration: 1500,
      });
    }
  }, [saved]);

  useUpdateEffect(() => {
    if (error && 'save' in error && error.save) {
      setSnack({
        open: true,
        onClose: handleSnackClose,
        message: '로봇 등록 도중 오류가 발생하였습니다.',
        severity: 'error',
      });
    }
  }, [error]);

  const onSave = () => {
    const { userId, serials } = state.registerItem;
    dispatch(onDirectSaveItem({ userId, serials }));
  };

  useMount(() => dispatch(initRegisterItem()));

  return (
    <>
      <AccordionCard
        {...{
          title: '로봇 등록',
          done: { label: '완료', onClick: onSave, disabled: doneDisabled },
          fold: { label: '접기', onClick: onClose },
          unfold: { label: '등록', onClick: onOpen },
        }}
        open={open}
      >
        <Grid container>
          <Grid item xs={12}>
            <RobotDirectRegisterCard
              {...registerItem}
              key="card"
              onCancel={() => dispatch(initRegisterItem())}
              onComplete={() => onSave()}
              onChange={(v, n) => onItemChange({ v, n })}
              name="register"
            />
          </Grid>
        </Grid>
      </AccordionCard>
      <Toast {...{ ...snack }} />
    </>
  );
};

export default RobotRegisterContainer;
